<template>
	<div>
		<!-- <vue-advanced-chat
			height="calc(100vh - 20px)"
			:current-user-id="currentUserId"
			:rooms="JSON.stringify(rooms)"
			:rooms-loaded="true"
			:users="JSON.stringify(users)"
			:users-loaded="true"
			:messages="JSON.stringify(messages)"
			:messages-loaded="messagesLoaded"
			@send-message="sendMessage($event.detail[0])"
			@fetch-messages="fetchMessages($event.detail[0])"
		/> -->



		<vue-advanced-chat
			height="calc(100vh - 80px)"
			:current-user-id="currentUserId"
			:room-id="roomId"
			:rooms="JSON.stringify(rooms)"
			:rooms-loaded="true"
			:messages="JSON.stringify(messages)"
			:messages-loaded="messagesLoaded"
			:room-message="roomMessage"
			:room-actions="JSON.stringify(roomActions)"
			:menu-actions="JSON.stringify(menuActions)"
			:message-selection-actions="JSON.stringify(messageSelectionActions)"
			:templates-text="JSON.stringify(templatesText)"
			@fetch-messages="fetchMessages($event.detail[0])"
			@send-message="sendMessage($event.detail[0])"
			@edit-message="editMessage($event.detail[0])"
			@delete-message="deleteMessage($event.detail[0])"
			@open-file="openFile($event.detail[0])"
			@open-user-tag="openUserTag($event.detail[0])"
			@add-room="addRoom($event.detail[0])"
			@room-action-handler="menuActionHandler($event.detail[0])"
			@menu-action-handler="menuActionHandler($event.detail[0])"
			@message-selection-action-handler="
				messageSelectionActionHandler($event.detail[0])
			"
			
			
			@toggle-rooms-list="$emit('show-demo-options', $event.detail[0].opened)"
		>
			<!-- <div
				v-for="message in messages"
				:slot="'message_' + message._id"
				:key="message._id"
			>
				New message container
				
				reacciones
				@send-message-reaction="sendMessageReaction($event.detail[0])"
				@typing-message="typingMessage($event.detail[0])"
			</div> -->
		</vue-advanced-chat>



		<!-- <div>
			<b-modal ref="newRoom" centered title="Buscar Contacto">
				<p class="my-4">Vertically centered modal!</p>
			</b-modal>
		</div> -->


		<b-modal ref="newRoom" size="md" centered title="Buscar Contacto">

			 <!-- <form ref="form" >
				<b-form-group>
				<b-form-input
					id="name-input"
					v-model="nuevochat.Persona"
					
				></b-form-input>
				</b-form-group>
			</form> -->


			<div class="col-12">
            <h5 class="text-primary"> <b> Buscar por numero de celular o nombre </b></h5>

				<!-- <label >Numero</label> -->
				<vue-bootstrap-typeahead
					:data="personas"
					v-model="queryPersona"
					:serializer="(item) => item.Celular + ' - ' + item.Persona"
					placeholder="Escriba el celular de la persona..."
					@hit="
						selectedPersona = $event;
						nuevochat.idPersona2 = $event.id;
					"
				/>
				
			</div>
           
            <template #modal-footer>
                <a  @click="verificarNuevaConversacion" class="btn btn-success">
					
                   <i class="ti-themify-favicon-alt" ></i> INICIAR CHAT
                </a>
                <a @click="cerrarmodalroom" class="btn btn-warning">
                   <i class="ti-close"></i> CANCELAR
                </a>
            </template>
        </b-modal>



	</div>

	

</template>

<script>
import { register } from 'vue-advanced-chat'
import MainService from "@/services/MainService.js";
// import { register } from '../../vue-advanced-chat/dist/vue-advanced-chat.es.js'
register()

export default {
	metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
	// props: {
	// 	currentUserId: { type: String, required: true },
	// 	theme: { type: String, required: true },
	// 	isDevice: { type: Boolean, required: true }
	// },

	data() {
		return {
			ss: new MainService(),
			rutaApp:process.env.VUE_APP_RRHH_SERVICE,
			nuevochat:{},
			currentUserId: 0,
			roomId:'1',
			loadingRooms: true,
			roomsLoaded: false,
			roomMessage: '',
			roomActions: [
				{ name: 'inviteUser', title: 'Invite User' },
				{ name: 'removeUser', title: 'Remove User' },
				{ name: 'deleteRoom', title: 'Delete Room' }
			],
			menuActions: [
				{ name: 'inviteUser', title: 'Invite User' },
				{ name: 'removeUser', title: 'Remove User' },
				{ name: 'deleteRoom', title: 'Delete Room' }
			],
			messageSelectionActions: [{ name: 'deleteMessages', title: 'Delete' }],
			typingMessageCache: '',

			templatesText: [
				{
					tag: 'help',
					text: 'This is the help'
				},
				{
					tag: 'action',
					text: 'This is the action'
				},
				{
					tag: 'action 2',
					text: 'This is the second action'
				}
			],
			
			rooms:[],
			// rooms: [
			// 	{
			// 		roomId: '1',
			// 		roomName: 'EMI',
			// 		avatar: 'https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj',
			// 		users: [
			// 			{ _id: '1234', username: 'John Doe' },
			// 			{ _id: '4321', username: 'John Snow' }
			// 		]
			// 	},
			// 	{
			// 		roomId: '2',
			// 		roomName: 'Prueba',
			// 		avatar: 'https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj',
			// 		users: [
			// 			{ _id: '1234', username: 'Henry' },
			// 			{ _id: '4321', username: 'Jorge' }
			// 		]
			// 	}
			
			// ],

			mensajeSeleccionado:{},

			// users: [
			// 	{
			// 		_id: '6R0MijpK6M4AIrwaaCY2',
			// 		username: 'Luke',
			// 		avatar: 'https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj'
			// 	},
			// 	{
			// 		_id: 'SGmFnBZB4xxMv9V4CVlW',
			// 		username: 'Leia',
			// 		avatar: 'https://avatarfiles.alphacoders.com/184/thumb-184913.jpg'
			// 	},
			// 	{
			// 		_id: '6jMsIXUrBHBj7o2cRlau',
			// 		username: 'Yoda',
			// 		avatar:
			// 			'https://vignette.wikia.nocookie.net/teamavatarone/images/4/45/Yoda.jpg/revision/latest?cb=20130224160049'
			// 	}
			// ],
			messages: [],
			messagesLoaded: false,
            personas: [],
			queryPersona: "",
			auth:{},
			conversaciones:[],
			isLoadingFile:false

		}
	},

	methods: {
		fetchMessages({ room, options = {} }) {

			this.selectedRoom = room.roomId;
			// this.addMessages(false);
			// console.log(room)
			// console.log("options",options);
			setTimeout(() => {
				if (options.reset) {
					// console.log("hola");
					this.messages = this.addMessages(false)
				} else {
					// this.messages = [...this.addMessages(), ...this.messages]
					// console.log("hola dos");

					this.messagesLoaded = true
				}
				// this.addNewMessage()
			})

			// this.ss.listMensaje(this.selectedRoom).then(
            //     (result) => {
            //         let response = result.data;
            //         this.messages = response.data;

			// 		this.messagesLoaded = true
            //     }
            // ).catch(error => {
            //     console.log(error);
            // });
		},

	
	


		addMessagesOriginal(reset) {

    //   console.log("rest",reset);
			const messages = []

			if(this.selectedRoom == 7){
			// for (let i = 0; i < 5; i++) {
				messages.push(
					{
					_id: 1,
					content: 'room 1',
					senderId: '4321',
					username: 'John Doe',
					date: '13 November',
					timestamp: '10:20',
					disableActions: false,
    				disableReactions: false,
					failure: true,
					reactions:{
						"🤔": ['1234', // USER_ID
        				'4321']
					},
					 files: [
					{
						name: 'My File',
						size: 67351,
						type: 'png',
						audio: true,
						duration: 14.4,
						url: 'https://img.freepik.com/foto-gratis/amor-romance-perforado-corazon-papel_53876-87.jpg',
						// preview: 'data:image/png;base64,iVBORw0KGgoAA...',
						// progress: 100
					}
					],


					
					},
          			{
					_id: 2,
					content: 'hola',
					senderId: '1234',
					username: 'John Doe',
					date: '13 November',
					timestamp: '10:20'
					}
				
				
				)
			// }
			};

			if(this.selectedRoom == 1){
			// for (let i = 0; i < 5; i++) {
				messages.push(
					{
					_id: 3,
					content: 'room 2',
					senderId: '4321',
					username: 'John Doe',
					date: '13 November',
					timestamp: '10:20',

					replyMessage: {
					content: 'respuesta',
					senderId: '4321',
					// files: [
					// 	{
					// 	name: 'My Replied File',
					// 	size: 67351,
					// 	type: 'png',
					// 	audio: true,
					// 	duration: 14.4,
					// 	url: 'https://firebasestorage.googleapis.com/...',
					// 	preview: 'data:image/png;base64,iVBORw0KGgoAA...'
					// 	}
					// ]
					},

					}
				
		
				)
			// }
			}


			return messages
		},


		addMessages(reset) {

			console.log("rest",reset);	
			console.log("this.selectedRoom",this.selectedRoom);	
			// const messages = []


			this.ss.listMensaje(this.selectedRoom).then(
                (result) => {
                    let response = result.data;
                    this.messages = response.data;

					console.log("mensajessss",this.messages);

					this.messagesLoaded = true
                }
            ).catch(error => {
                console.log(error);
            });

			// if(this.selectedRoom == 16){
			
			// 	messages.push(
			// 		{
			// 		_id: 1,
			// 		content: 'room 1',
			// 		senderId: '1749',
			// 		username: 'JORGE ANDRES TROCEL JUSTINIANO',
			// 		date: '13 November',
			// 		timestamp: '10:20',
			// 		disableActions: false,
    		// 		disableReactions: false,
			// 		failure: true,
			// 		reactions:{
			// 			"🤔": ['1234', // USER_ID
        	// 			'4321']
			// 		},
			// 		 files: [
			// 		{
			// 			name: 'My File',
			// 			size: 67351,
			// 			type: 'png',
			// 			audio: true,
			// 			duration: 14.4,
			// 			url: 'https://img.freepik.com/foto-gratis/amor-romance-perforado-corazon-papel_53876-87.jpg',
			// 			// preview: 'data:image/png;base64,iVBORw0KGgoAA...',
			// 			// progress: 100
			// 		}
			// 		],


					
			// 		},
          	// 		{
			// 		_id: 2,
			// 		content: 'hola',
			// 		senderId: '834',
			// 		username: 'HENRY FERNANDO MORALES CONDORI',
			// 		date: '13 November',
			// 		timestamp: '10:20'
			// 		}
				
				
			// 	)
			// };

	
			// return messages
		},
		async sendMessageReaction({ reaction, remove, messageId, roomId }) {
			
			// console.log("reaction",reaction);
			// console.log("reaction",reaction.unicode);
			// console.log("mensajes",this.messages);
			console.log("mensajes",this.messages[0].reactions);

		
			

			this.messages.map(function(dato){

			
			
			if(dato._id === messageId){



				dato.content = "reaccion";
				
				let objetouni=reaction.unicode;

				let emo = '"'+reaction.unicode+'"';
				
				dato.reactions ={
						emo: ['1234','4321']
				}
				
				console.log("dato",dato);
				// console.log("objetouni",objetouni);
				console.log("emo",emo);

			}
			});

		},


		loadFile(input) {
			// this.isLoadingFile = true;
			// input = event.target;
			// console.log("input",input);

			// var reader = new FileReader();
			// console.log("reader",reader);
			// reader.readAsDataURL(input.files[0]);
			// var data = new FormData();
			// data.append('File', input.files[0]);

			// console.log("data upload",data);
			// 	this.ss.uploadFile(data)
			// 		.then(result => {
			// 			if (result.data.success) {
			// 				this.$bvToast.toast(
			// 					result.data.msg,
			// 					{
			// 						title: 'Correcto',
			// 						variant: 'info',
			// 						autoHideDelay: 5000
			// 					}
			// 				)
			// 				// this.persona.Foto = result.data.data;

			// 				return result.data.data;
			// 			} else {
			// 				this.$bvToast.toast(
			// 					result.data.msg,
			// 					{
			// 						title: 'Oops!',
			// 						variant: 'danger',
			// 						autoHideDelay: 5000
			// 					}
			// 				)
			// 				return false;
			// 			}
			// 			// this.isLoadingFile = false;
			// 		})
				
		},

		getBlobFromUrl (bUrl) {
			new Promise((resolve, reject) => {
				let xhr = new XMLHttpRequest()
				xhr.responseType = 'blob'
				xhr.addEventListener('load', event => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				} else {
					reject(new Error('Cannot retrieve blob'))
				}
				})

				xhr.open('GET', bUrl, true)
				return xhr.send()
			})
		},


		sendMessage(message) {
			// console.log("enviar mensaje room",this.selectedRoom);
			// console.log("message",message.replyMessage);



			// responder mensaje -- listo
			if (message.replyMessage && !message.files){
			
	
				
				// 	this.messages = [
				// ...this.messages,
				// 	{
				// 		_id: this.messages.length,
				// 		content: message.content,
				// 		senderId: this.currentUserId,
				// 		timestamp: new Date().toString().substring(16, 21),
				// 		date: new Date().toDateString(),

				// 		replyMessage: {
				// 			content: message.replyMessage.content,
				// 			senderId: message.replyMessage.senderId,
				
				// 		},

				// 	}
				// ]

				let mensajeNuevo = {};
				let respuesta={};
				
				
				respuesta.content = message.replyMessage.content;
				respuesta.senderId = message.replyMessage.senderId;

				mensajeNuevo.idConversacion =  this.selectedRoom;
				mensajeNuevo.content =  message.content;
				mensajeNuevo.Persona =  this.auth.id;
				mensajeNuevo.senderId =  this.currentUserId;
				mensajeNuevo.username =  this.auth.Persona;
				mensajeNuevo.timestamp =   new Date().toString().substring(16, 21);
				mensajeNuevo.date =  new Date().toDateString();

				mensajeNuevo.replyMessage =  respuesta;


				this.ss.storeMensaje(mensajeNuevo).then(
                (result) => {
                    // console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
					this.addMessages(false);
					// this.fetchMessages();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });



				

			};

			// responder mensaje con archivos

			if (message.files && message.replyMessage) {
				message.files = this.formattedFiles(message.files)
				console.log(" file ",message.files);

				// console.log(" mensaje ",mess	age);

				message.files.forEach(f => {
				console.log(" for each ");
				
				let type = f.extension || f.type
					if (type === 'svg' || type === 'pdf') {
						type = f.type
						console.log(" mensaje type ",type);
						

					}



				this.messages = [
				...this.messages,
					{
						_id: this.messages.length,
						content: message.content,
						senderId: this.currentUserId,
						timestamp: new Date().toString().substring(16, 21),
						date: new Date().toDateString(),

						replyMessage: {
							content: message.replyMessage.content,
							senderId: message.replyMessage.senderId,
				
						},

						files: [
							{
								name: f.name,
								size: f.size,
								type: type,
								// audio: true,
								// duration: 14.4,
								// url: 'https://img.freepik.com/foto-gratis/amor-romance-perforado-corazon-papel_53876-87.jpg',
								url: f.url,
								// preview: 'data:image/png;base64,iVBORw0KGgoAA...',
								// progress: 100
							}
							],
					}
				]

				})

			}
			


			// enviar archivos

			if (message.files && !message.replyMessage) {
				message.files = this.formattedFiles(message.files)
				console.log(" file ",message.files);

				// console.log(" mensaje ",mess	age);

				message.files.forEach(f => {
				console.log(" for each ");
				
				let type = f.extension || f.type
					if (type === 'svg' || type === 'pdf') {
						type = f.type
						console.log(" mensaje type ",type);
						

					}



				// this.messages = [
				// ...this.messages,
				// 	{
				// 		_id: this.messages.length,
				// 		content: message.content,
				// 		senderId: this.currentUserId,
				// 		timestamp: new Date().toString().substring(16, 21),
				// 		date: new Date().toDateString(),
				// 		files: [
				// 			{
				// 				name: f.name,
				// 				size: f.size,
				// 				type: type,
				// 				// audio: true,
				// 				// duration: 14.4,
				// 				// url: 'https://img.freepik.com/foto-gratis/amor-romance-perforado-corazon-papel_53876-87.jpg',
				// 				url: f.url,
				// 				// preview: 'data:image/png;base64,iVBORw0KGgoAA...',
				// 				// progress: 100
				// 			},
							
				// 			],
				// 	}
				// ]

				
				

				// let subir = false;
				// subir = this.loadFile(f.url);
				// subir = this.getBlobFromUrl(f.url);
				// console.log("subir",f.file);


				const fetch = require('node-fetch');
				// const fs = require('fs');
				const fs = require('fs-extra');

				const url = f.url;

				fetch(url)
				.then(response => {
					if (response.ok) {
					return response.blob();
					} else {
					throw new Error('No se pudo descargar la imagen.');
					}
				})
				.then(blob => {
					const reader = new FileReader();
					reader.onloadend = () => {
					const imageBinary = Buffer.from(reader.result);
					fs.writeFile('AYRTON.jpeg', imageBinary, 'binary', (err) => {
						if (err) {
						console.error('Error al guardar la imagen:', err);
						} else {
						console.log('La imagen se ha descargado correctamente.');
						}
					});
					};
					reader.readAsArrayBuffer(blob);
				})
				.catch(error => {
					console.error('Error al descargar la imagen:', error);
				});

				// this.ss.uploadFile(f)
                //     .then(result => {
                //         if (result.data.success) {
                //             this.$bvToast.toast(
                //                 result.data.msg,
                //                 {
                //                     title: 'Correcto',
                //                     variant: 'info',
                //                     autoHideDelay: 5000
                //                 }
                //             )
                //             // this.persona.Foto = result.data.data;
                //         } else {
                //             this.$bvToast.toast(
                //                 result.data.msg,
                //                 {
                //                     title: 'Oops!',
                //                     variant: 'danger',
                //                     autoHideDelay: 5000
                //                 }
                //             )
                //         }
                //         // this.isLoadingFile = false;
                //     })
                //     .catch(error => {
                //         console.log(error);
                //         this.$bvToast.toast(
                //             'Error subiendo archivo',
                //             {
                //                 title: 'Oops!',
                //                 variant: 'danger',
                //                 autoHideDelay: 5000
                //             }
                //         )
                //         // this.isLoadingFile = false;
                //     });

				
			

				


				// let canvas = document.createElement('canvas'); 
				// canvasContext = canvas.getContext && canvas.getContext('2d'); 
				// canvas.height = img.naturalHeight; 
				// canvas.width = img.naturalWidth; 
				// canvasContext.drawImage(img, 0, 0); 
				// let imgBase64 = canvas.toDataURL('image/png'); 
				// download(imgBase64, 'filename.png');



			// guardar

				// let mensajeNuevo = {};

				// mensajeNuevo.idConversacion =  this.selectedRoom;
				// mensajeNuevo.content =  message.content;
				// mensajeNuevo.Persona =  this.auth.id;
				// mensajeNuevo.senderId =  this.currentUserId;
				// mensajeNuevo.username =  this.auth.Persona;
				// mensajeNuevo.timestamp =   new Date().toString().substring(16, 21);
				// mensajeNuevo.date =  new Date().toDateString();
			
				// let archivos = [];
				// let objetoarchivo ={};

				// objetoarchivo= { "name": f.name, "size":f.size, "type": type, "url": f.url};
				// archivos = [objetoarchivo]

				// mensajeNuevo.files = archivos;

				// console.log("mensaje de archivos",mensajeNuevo.files);

				// this.ss.storeMensaje(mensajeNuevo).then(
                // (result) => {
                //     // console.log(result);
                //     let response = result.data;
                //     this.$bvToast.toast(
                //         response.msg,
                //         {
                //             title: 'Correcto',
                //             variant: 'success',
                //             autoHideDelay: 5000
                //         }
                //     )
				// 	this.addMessages(false);
				// 	// this.fetchMessages();
                // })
                // .catch((error) => {
                //     this.errorBag = error.response.data.errors;
                //     this.$bvToast.toast(
                //         'Problema al Guardar el Registro, favor verificar los Datos',
                //         {
                //             title: 'Error',
                //             variant: 'danger',
                //             autoHideDelay: 5000
                //         }
                //     )
                // });


				})

				// const { id } = this.messages.length;
				// const { roomId } = this.selectedRoom;

				// if (message.files) {
				// 	for (let index = 0; index < message.files.length; index++) {
				// 		this.uploadFile({ file: message.files[index], messageId: id, roomId })
				// 	}
				// }


			

				


			}
			
			
			// enviar mensajes normales -- listo
			if (!message.files && !message.replyMessage){
				
				// this.messages = [
				// 	...this.messages,
				// 	{
				// 		_id: this.messages.length,
				// 		content: message.content,
				// 		senderId: this.currentUserId,
				// 		timestamp: new Date().toString().substring(16, 21),
				// 		date: new Date().toDateString()
				// 	}
				// ]

				let mensajeNuevo = {};

				
				mensajeNuevo.idConversacion =  this.selectedRoom;
				mensajeNuevo.content =  message.content;
				mensajeNuevo.Persona =  this.auth.id;
				mensajeNuevo.senderId =  this.currentUserId;
				mensajeNuevo.username =  this.auth.Persona;
				mensajeNuevo.timestamp =   new Date().toString().substring(16, 21);
				mensajeNuevo.date =  new Date().toDateString();


				this.ss.storeMensaje(mensajeNuevo).then(
                (result) => {
                    // console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
					this.addMessages(false);
					// this.fetchMessages();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });

			}

			
		},

		async uploadFile({ file, messageId, roomId }) {
			console.log("subir archivo");


			return new Promise(resolve => {
				let type = file.extension || file.type
				if (type === 'svg' || type === 'pdf') {
					type = file.type


				}
					console.log("type",type);

				this.messages = [	
				...this.messages,
				{
					_id: messageId,
					// content: message.content,
					senderId: this.currentUserId,
					timestamp: new Date().toString().substring(16, 21),
					date: new Date().toDateString(),
					file: file.url
				}
				]	

				


				// message.files.forEach(f => {
				// 	if (f.url === file.localUrl) {
				// 		f.url = url
				// 	}
				// })

				

			// const messages = []
			

			// if(this.selectedRoom == '1'){
			// 	messages.push(
			// 		{
			// 		_id: 4,
			// 		content: 'archivo',
			// 		senderId: '4321',
			// 		username: 'John Doe',
			// 		date: '13 November',
			// 		timestamp: '10:20'
			// 		}
				
		
			// 	)
			// }

				// storageService.listenUploadImageProgress(
				// 	this.currentUserId,
				// 	messageId,
				// 	file,
				// 	type,
				// 	progress => {
				// 		this.updateFileProgress(messageId, file.localUrl, progress)
				// 	},
				// 	_error => {
				// 		resolve(false)
				// 	},
				// 	async url => {
				// 		const message = await firestoreService.getMessage(roomId, messageId)

				// 		message.files.forEach(f => {
				// 			if (f.url === file.localUrl) {
				// 				f.url = url
				// 			}
				// 		})

				// 		await firestoreService.updateMessage(roomId, messageId, {
				// 			files: message.files
				// 		})
				// 		resolve(true)
				// 	}
				// )
			})
		},
		formattedFiles(files) {
			const formattedFiles = []

			files.forEach(file => {
				const messageFile = {
					name: file.name,
					size: file.size,
					type: file.type,
					extension: file.extension || file.type,
					url: file.url || file.localUrl
				}

				if (file.audio) {
					messageFile.audio = true
					messageFile.duration = file.duration
				}

				formattedFiles.push(messageFile)
			})

			return formattedFiles
		},

	

		addNewMessage() {
			setTimeout(() => {
				this.messages = [
					...this.messages,
					{
						_id: this.messages.length,
						content: 'NEW MESSAGE',
						senderId: '1234',
						timestamp: new Date().toString().substring(16, 21),
						date: new Date().toDateString()
					}
				]
			}, 2000)
		},


		// typingMessage({ message, roomId }) {

		// 	// console.log("roomId",roomId);

		// 	// console.log("message",message);
		// 	if (roomId) {
		// 		if (message?.length > 1) {
		// 			this.typingMessageCache = message;
		// 			// console.log("typingMessageCache",this.typingMessageCache);

		// 			return
		// 		}

		// 		if (message?.length === 1 && this.typingMessageCache) {
		// 			this.typingMessageCache = message

		// 			// console.log("typingMessageCache dos");

		// 			return
		// 		}

		// 		this.typingMessageCache = message

			

		// 		// firestoreService.updateRoomTypingUsers(
		// 		// 	roomId,
		// 		// 	this.currentUserId,
		// 		// 	message ? 'add' : 'remove'
		// 		// )
		// 	}
		// },


		async deleteMessage({ message, roomId }) {

			console.log("borrar mensaje",message)
			// await firestoreService.updateMessage(roomId, message._id, {
			// 	deleted: new Date()
			// })

			// const { files } = message

			// if (files) {
			// 	files.forEach(file => {
			// 		storageService.deleteFile(this.currentUserId, message._id, file)
			// 	})
			// }
		},

		messageSelectionActionHandler({ action, messages, roomId }) {

			console.log("borrar mensaje",messages)
			console.log("borrar roomId",roomId)
			console.log("borrar action",action)

			// switch (action.name) {
			// 	case 'deleteMessages':
			// 		messages.forEach(message => {
			// 			this.deleteMessage({ message, roomId })
			// 		})
			// }
		},

		async editMessage({ messageId, newContent, roomId, files }) {

			console.log("editar mensaje",messageId)
			console.log("editar newContent",newContent)
			console.log("editar roomId",roomId)
			console.log("editar files",files)

			// const newMessage = { edited: new Date() }
			// newMessage.content = newContent

			// if (files) {
			// 	newMessage.files = this.formattedFiles(files)
			// } else {
			// 	newMessage.files = firestoreService.deleteDbField
			// }

			// await firestoreService.updateMessage(roomId, messageId, newMessage)

			// if (files) {
			// 	for (let index = 0; index < files.length; index++) {
			// 		if (files[index]?.blob) {
			// 			await this.uploadFile({ file: files[index], messageId, roomId })
			// 		}
			// 	}
			// }
		},

		addRoom() {

			console.log("anadir chat");
			this.$refs['newRoom'].show();

			// this.resetForms()
			// this.addNewRoom = true
		},

		buscarmodalroom(){
			// this.$refs['newRoom'].show();
			console.log("buscar");
		},

		cerrarmodalroom(){
			this.$refs['newRoom'].hide();
		},

		resetForms() {
			this.disableForm = false
			this.addNewRoom = null
			this.addRoomUsername = ''
			this.inviteRoomId = null
			this.invitedUsername = ''
			this.removeRoomId = null
			this.removeUserId = ''
		},

		inviteUser(roomId) {
			this.resetForms()
			this.inviteRoomId = roomId
		},

		removeUser(roomId) {
			this.resetForms()
			this.removeRoomId = roomId
			this.removeUsers = this.rooms.find(room => room.roomId === roomId).users
		},

		crearChat(){
			let usuarios1 = [];
			let usuarios2 = [];
			let usuarioUno ={};
			let usuarioDos ={};
			// console.log("persoa selecionada",this.selectedPersona);
			this.nuevochat.idPersona1 = this.auth.id;
			this.nuevochat.roomName1 = this.auth.Persona;
			this.nuevochat.avatar1 = this.rutaApp + 'storage/documents/' + this.auth.Foto;


			this.nuevochat.roomName2 = this.selectedPersona.Persona;
			this.nuevochat.avatar2 = this.rutaApp + 'storage/documents/' + this.selectedPersona.Foto;
			// this.nuevochat.avatar = this.selectedPersona.URLFoto;

			usuarioUno= { _id: this.auth.id, username: this.auth.Persona };
			usuarioDos= { _id: this.selectedPersona.id, username: this.selectedPersona.Persona };
			usuarios1 = [usuarioUno,usuarioDos]
			usuarios2 = [usuarioDos,usuarioUno]

			this.nuevochat.users1 = usuarios1;
			this.nuevochat.users2 = usuarios2;
			
			// console.log("nuevo chat con",this.queryPersona);
			// console.log("nuevo chat con",this.nuevochat);

			this.ss.storeConversacion(this.nuevochat).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    // console.log(response);
					this.getConversaciones();
                    this.$refs['newRoom'].hide();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
		},

		verificarNuevaConversacion() {

			this.nuevochat.idPersona1 = this.auth.id;
            this.ss.verificarConversacion(this.nuevochat).then(
                (result) => {
                    let response = result.data;
                    // this.rooms = response.data;
					if(response.success == true){
						console.log("true",response.msg);
						this.crearChat();
					};

					if(response.success == false){
						console.log("false",response.msg);

						this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    	)

						return

					}
                }
            ).catch(error => {
                console.log(error);
            });
        },


		getConversaciones() {
            this.ss.listConversacion(this.auth.id).then(
                (result) => {
                    let response = result.data;
                    this.rooms = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },



	

	},

	watch: {
        queryPersona(q) {
            this.ss.select2Persona(q).then((res) => {
                console.log(res);
                if (res.data.success) {
                    this.personas = res.data.items;
					
                } else {
                    this.personas = [];
                }
            })
        }
    },

	mounted() {
		// this.addCss()

		// this.fetchRooms()
		// firebaseService.updateUserOnlineStatus(this.currentUserId)

		this.auth = JSON.parse(localStorage.getItem('usuario'));
        // console.log(this.auth);
        if (!this.auth) {
            this.$router.push('/Login');
        } else {
            
            // this.showPersona();
            // this.print();
			// this.currentUserId = "'"+this.auth.id+"'";
			this.currentUserId = this.auth.id;
			console.log("current",this.currentUserId);
			this.getConversaciones();
            
        }

	},
}
</script>

<style lang="scss">
body {
	font-family: 'Quicksand', sans-serif;
}
</style>
